export enum LorenzControlTypeEnum {
	UNKNOWN = 'unknown',

	LIST = 'list',
	LISTITEM = 'listitem',

	CHECKBOX = 'checkbox',
	DATE = 'date',
	EMAIL = 'email',
	HIDDEN = 'hidden',
	IMAGE_PASTE = 'image-paste',
	HTML = 'html',
	DOCUMENT_UPLOAD = 'document-upload',
	OBJECT = 'object',
	RADIO = 'radio',
	SELECT = 'select',
	TEXT = 'text',
	TEXTAREA = 'textarea',
	TIME = 'time'
}
